import React, { Component } from 'react';
import {
  TouchableOpacity,
  ScrollView,
  View,
  Image,
  ImageBackground,
  ImageFit,
  Text,
  StyleSheet,
} from '../../../shared/custom-react-native';
import UI from '../../../shared/Components/UI/js';
import { Button } from 'react-bootstrap';
import IconTint from 'react-icon-tint';

// CSS
import './TourHotelList.scss';

export default class TourHotelList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tourItems: this.props._this.state.tourList,
      hotelItems: this.props._this.state.hotelList,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    // console.log('State', this.state);

    if (prevProps !== this.props) {
      this.setState({
        tourItems: this.props._this.state.tourList,
        hotelItems: this.props._this.state.hotelList,
      });
    }
  }

  render() {
    const _this = this.props._this;
    const type = this.props.type;
    const { tourItems, hotelItems } = this.state;

    return (
      <div className='list-cont'>
        {type === 'tour' && (
          <>
            {tourItems &&
              tourItems.length > 0 &&
              tourItems.map((destination) => {
                return (
                  <Item
                    _this={_this}
                    destination={destination}
                  />
                );
              })}

            {!tourItems ||
              (!tourItems.length > 0 && (
                <div>
                  <h2 style={{ fontSize: 16 }}>
                    No Past Booking, Book more and enjoy.
                  </h2>
                </div>
              ))}
          </>
        )}

        {type === 'hotel' && (
          <>
            {hotelItems &&
              hotelItems.length > 0 &&
              hotelItems.map((destination) => {
                return (
                  <Item
                    _this={_this}
                    destination={destination}
                  />
                );
              })}

            {!hotelItems ||
              (!hotelItems.length > 0 && (
                <div>
                  <h2 style={{ fontSize: 16 }}>
                    No Past Booking, Book more and enjoy.
                  </h2>
                </div>
              ))}
          </>
        )}
      </div>
    );
  }
}

const Item = ({ _this, destination }) => {
  const onClick = () => {
    UI.goTo(
      `/booking-history/${destination.bookingId}?type=${destination.type}`,
    );
  };
  console.log(destination);
  return (
    <div
      onClick={onClick}
      className='list-item'
    >
      <img
        className='list-image'
        src={destination?.historyDetails?.primaryImageURL}
        alt={destination?.historyDetails?.title}
      />

      <div className='list-details'>
        <div className='first-row'>
          <h3 className='primary-text'>{destination?.historyDetails?.title}</h3>

          <div className='icons'>
            <img
              width={20}
              src={UI.STAR}
              alt='star'
              className='star'
            />

            <p className='rating'>{destination?.reviews?.overAllRating}</p>

            <div
              className='best-value'
              style={{
                display: destination?.isBestValue ? 'flex' : 'none',
              }}
            >
              <IconTint
                src={UI.VERIFIED}
                maxWidth={20}
                maxHeight={20}
                color={'#006fb9'}
              />

              <p className='verified-text'>Best Value</p>
            </div>
          </div>
        </div>

        <div className='line'></div>

        <div className='second-row'>
          <div className='first-line'>
            <div className='location'>
              <IconTint
                src={UI.LOCATION}
                maxWidth={20}
                maxHeight={20}
                color={'#646464'}
              />

              <p className='hotel-location'>
                {destination?.historyDetails?.location}
              </p>
            </div>

            <div className='calendar'>
              <IconTint
                src={UI.CALENDAR}
                maxWidth={20}
                maxHeight={20}
                color={'#646464'}
              />

              <p className='hotel-date'>{`${destination?.checkIn} - ${destination?.checkOut}`}</p>
            </div>
          </div>

          <div className='second-line'>
            <IconTint
              src={UI.STAR}
              maxWidth={20}
              maxHeight={20}
              color={'#646464'}
            />

            <p className='hotel-address'>
              {destination?.historyDetails?.places}
            </p>
          </div>
        </div>

        <div className='third-row'>
          <p className='rating'>
            Your Rating:{' '}
            {userRatingFn(
              destination?.reviews?.customerRating,
              destination?.reviews?.hasRating,
              _this,
              destination.bookingId,
              destination.type,
            )}
          </p>

          <div className='price'>
            <p className='text-header'>
              <span>Amount Paid Php</span>{' '}
              {parseFloat(destination?.totalPrice).toLocaleString()}
            </p>

            {destination?.isInclusive && (
              <span className='tax-inclusive'>Inclusive of Taxes</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const userRatingFn = (userRating, rating, _this, id, type) => {
  if (!rating) {
    return (
      <Button
        className='rate-now-button'
        onClick={(e) => {
          e.stopPropagation();
          _this.openReviewModal(id, type);
        }}
      >
        Rate Now
      </Button>
    );
  }

  return <>{userRating}</>;
};
